// Advanced mixed-language font detection
document.addEventListener('DOMContentLoaded', function() {
  
  // Function to detect if text is primarily Hebrew
  function isHebrewText(text) {
    if (!text) return false;
    
    // Count Hebrew vs Latin characters
    const hebrewChars = (text.match(/[\u0590-\u05FF\uFB1D-\uFB4F]/g) || []).length;
    const latinChars = (text.match(/[a-zA-Z]/g) || []).length;
    
    // If more than 30% of alphabetic characters are Hebrew, treat as Hebrew
    return hebrewChars > 0 && (hebrewChars / (hebrewChars + latinChars)) > 0.3;
  }
  
  // Process all text elements
  function processElement(element) {
    // Skip if already processed
    if (element.hasAttribute('data-font-processed')) return;
    
    // Skip if has explicit language attribute
    if (element.hasAttribute('lang')) return;
    
    // Get direct text content (not from children)
    let directText = '';
    for (let node of element.childNodes) {
      if (node.nodeType === 3) { // Text node
        directText += node.textContent;
      }
    }
    
    if (directText.trim()) {
      if (isHebrewText(directText)) {
        element.classList.add('hebrew');
        element.setAttribute('lang', 'he');
      } else if (/[a-zA-Z]/.test(directText)) {
        element.classList.add('english');
        element.setAttribute('lang', 'en');
      }
    }
    
    element.setAttribute('data-font-processed', 'true');
  }
  
  // Process all relevant elements
  const selector = 'h1, h2, h3, h4, h5, h6, p, span, a, button, li, td, th, label, .product-title, .product-description';
  const elements = document.querySelectorAll(selector);
  elements.forEach(processElement);
  
  // Observer for dynamically added content
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === 1) { // Element node
          if (node.matches && node.matches(selector)) {
            processElement(node);
          }
          // Process children
          const children = node.querySelectorAll(selector);
          children.forEach(processElement);
        }
      });
    });
  });
  
  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Log for debugging
  console.log('Mixed language font system initialized');
});